"use client";

import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface BAPBInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function BAPBInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: BAPBInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Biological Assets other than Bearer Plants"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
